import React from "react";
import { QueryObserverResult } from "react-query";
import {
  DataTypes,
  ImportType,
  MigrationSetImport,
  MigrationSetWithImports,
} from "../../shared";
import { Card, CardIconWrapper } from "../card";
import {
  getInvoicesDescription,
  getTemplateKey,
} from "../../functions/workflowFunctions";
import { CardDescription } from "../cardDescription";
import { InvoicesSVG, InvoicesUKSVG } from "../../icons";

interface CardInvoiceProps {
  currentMigrationSetId: number;
  data: { imports: MigrationSetImport[] } | undefined;
  cardsState: Record<string, any>;
  disableButtonAccess: boolean;
  refetchMigrationSet: () => Promise<
    QueryObserverResult<MigrationSetWithImports, unknown>
  >;
  region: string;
  invoiceType: string;
}

export const CardInvoice: React.FC<CardInvoiceProps> = ({
  currentMigrationSetId,
  data,
  cardsState,
  disableButtonAccess,
  refetchMigrationSet,
  region,
  invoiceType,
}) => {
  const invoiceImport = data?.imports.find((i) => i.importType === "invoice");
  const activeType: ImportType =
    invoiceType === "detailedInvoiceType" ? "invoiceDetailed" : "invoice";
  return (
    <Card
      image={
        region === "GB" ? (
          <CardIconWrapper>
            <InvoicesUKSVG />
          </CardIconWrapper>
        ) : (
          <CardIconWrapper>
            <InvoicesSVG />
          </CardIconWrapper>
        )
      }
      importType={"invoice"}
      templateKey={getTemplateKey(activeType, region)}
      fileName="invoice.csv"
      migrationSetId={currentMigrationSetId}
      migrationSetImport={invoiceImport}
      headerText={DataTypes.Invoices}
      description={
        <CardDescription
          {...getInvoicesDescription(region, invoiceImport, invoiceType)}
          displayWiderColumn={true} // Pass the displayWiderColumn flag prop as true for all invoices
        />
      }
      cardState={cardsState["invoice"]}
      disableButtonAccess={disableButtonAccess}
      refetchMigrationSet={refetchMigrationSet}
    />
  );
};
